import BaseProxy from './Proxy';

export default class CitaProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/cita', parameters);
  }

  init() {
    return this.submit('get', `${this.endpoint}/init`);
  }

  getRefUrl() {
    return this.submit('get', `${this.endpoint}/refurl`);
  }

  msisdnVerify(msisdn) {
    return this.submit('post', `${this.endpoint}/msisdn/verify`, { msisdn });
  }

  otpRequest() {
    return this.submit('get', `${this.endpoint}/otp/request`);
  }

  otpVerify(otp) {
    return this.submit('post', `${this.endpoint}/otp/verify`, { otp });
  }

  otpResend() {
    return this.submit('get', `${this.endpoint}/otp/resend`);
  }

  captchaReload() {
    return this.submit('get', `${this.endpoint}/captcha/reload`);
  }

  confirm(accept, csrf, otp, captcha) {
    return this.submit('post', `${this.endpoint}/confirm`, { accept, csrf, otp, captcha });
  }
}
